export type LanguageConfigType = { languages: LanguageItem[]; settings: LanguageSettings };

export type LanguageSettings = {
  defaultLanguageId: number | null;
  multilangEnabled: boolean;
  selectedLanguageId: number;
  language: CompanyLanguageCode;
};

export type CompanyLanguageCode = 'nl' | 'en' | 'de' | 'fr';

export type LanguageItem = {
  id: number;
  enabled: boolean;
  code: string;
  name: string;
  supported: boolean;
  primary: boolean;
};

export type PossibleLanguageItem = {
  code: string;
  name: string;
  nativeName: string;
};

export type LanguageTranslations = {
  careersTranslations: LanguageTranslationsItem[];
  viewboxTranslations: LanguageTranslationsItem[];
  careersSitesTranslations: LanguageTranslationsItem[];
  language: LanguageItem;
  careersCategories: LanguageCategoryItem[];
  viewboxCategories: LanguageCategoryItem[];
  careersSitesCategories: LanguageCategoryItem[];
};

export type LanguageCategoryItem = { categoryValue: string; categoryKey: string };

export type LanguageTranslationsItem = {
  categoryKey: string;
  value: string | null;
  originalValue: string;
  key: string;
  defaultValue?: string;
};

export enum LanguageDialogContext {
  EditCustom = 'edit_custom',
  EditDefault = 'edit_default',
  AddNew = 'add_new',
}

export type LanguageDialogContextType =
  | LanguageDialogContext.EditDefault
  | LanguageDialogContext.EditCustom
  | LanguageDialogContext.AddNew;

export type SetAsDefaultErrorData = { data: { locationIds: number[] }; code: string };
